<template>
    <div>
        <b-form-input v-if="value == null || typeof value == 'number' || (typeof value == 'string' && value.indexOf('\n') == -1)" :value="value" :title="value" :readonly="true"></b-form-input>
        <textarea-autosize v-else :value="value" :title="value" class="form-control"
                           :readonly="true"
                           :min-height="35"
                           :max-height="100" />
    </div>
</template>
<script>
    export default {
        name: 'InputAutoSize',
        props: ['value'],
        data() {
            return {
            }
        },
        mounted: function () {

        },
        methods: {

        },
        watch: {

        },
        destroyed: function () {

        }
    }
</script>

